import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";
import { stake_adduser, addTree } from "service";
import Header from "components/Layout/Header";


const LoadingButton = ({ className }) => {
  return (
    <button className={className}>
      <div className="spinner-border spinner-border-sm" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </button>
  );
};

const Login = (props) => {
  const state = useSelector((state) => state);
  const [value, setValue] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [check, setCheck] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    const ref = url.searchParams.get("ref");
    if (ref?.length) {
      setValue(ref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location]);

  console.log(state);
  if (state.user && state.user?.userAddress !== "0x0000000000000000000000000000000000000000" && state.user?.ref !== "0x0000000000000000000000000000000000000000") {
    window.location.replace('/')
  }
  const onSubmit = async () => {
    setLoading(true);
    const router = localStorage.getItem("router");

    // if () {
    console.log(value);
    // return;
    // }
    try {
      let abc = await addTree(value);

      console.log(abc);
      if (abc) {
        NotificationManager.success("Success", "Success", 10000);
        window.location.replace('/')

      }
    } catch (error) {
      console.log(error);
      NotificationManager.error("invalid address", "Error", 10000);
    }
    setLoading(false);

    // return;
    // setLoading(true);
    // const address = state.address_web3.toLowerCase();
    // let sponsorId, code;
    // sponsorId = value.split("/")[0].toLowerCase();
    // code = value.split("/")[1];
    // stake_adduser({ address, sponsorId, code }).then((res) => {
    //   if (!res.status && res.msg) {
    //     NotificationManager.error(res.msg, "Error", 10000);
    //   } else {
    //     NotificationManager.success("Success", "Success", 10000);
    //     window.location.replace('/')
    //   }
    //   setLoading(false);
    //   // dispatch(get_user(address));
    //   setTimeout(() => {
    //     props.history.push(router);
    //   }, 1000);
    // });

  };

  const onConnect = () => {
    window.ethereum.enable().then((res) => {
      if (res.length) {
        setCheck(true);
      }
    });
  };

  return (
    <>
      <Header props={props} />
      <div className="site-main-content__pools" style={{ marginTop: 150 }}>
        <div className="container">
          <div className="manage-your-wallet">
            <div className="modal-dialog" role="document">
              <div
                className="modal-content"
                style={{ background: "rgb(26, 33, 50)" }}
              >
                <div
                  className="modal-header"
                  style={{ borderBottomColor: "rgba(136, 138, 141, 0.37)" }}
                >
                  <h3 className="wallet-title">Add Referrer</h3>
                </div>
                <div className="modal-body ">
                  <input
                    className="form-control"
                    style={{
                      background: "rgb(255 255 255)",
                      border: "1px solid rgba(136, 138, 141, 0.37)",
                      color: "#161515",
                    }}
                    placeholder="Ref"
                    defaultValue={value}
                    onChange={(e) => {
                      setValue(e.target.value);
                    }}
                  />
                </div>
                <div
                  className="modal-footer"
                  style={{ borderTopColor: "rgba(136, 138, 141, 0.37)" }}
                >
                  {loading ? (
                    <>
                      <LoadingButton className="btn btn-primary" />
                      <LoadingButton className="btn btn-primary" />
                    </>
                  ) : (
                    <>
                      {!check ? (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={onConnect}
                        >
                          Connect Wallet
                        </button>
                      ) : null}
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={!value}
                        onClick={onSubmit}
                      >
                        Confirm
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="row m-0">
              <div className="col-6">
                <div className="sssfasf">WAITING ROOM</div>
              </div>
              <div className="col-6">
                <div className="s2asdasd">
                  <svg viewBox="64 64 896 896" focusable="false" data-icon="rise" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 000 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0013.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z"></path></svg>
                  JOIN NOW
                </div>
              </div>
            </div>
            <div className="row m-0">
              <div className="col-sm-6">
                <div></div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>

  );
};

export default Login;
